import { Box, darken, Stack, Typography, useTheme } from "@mui/material";

import { GqlProtocolVisit } from "~/__generated__";

import { VisitPossibility } from "../../types/ProtocolTypes";
import PossibleVisitIndicator from "./PossibleVisitIndicator";

type Props = {
    visit: GqlProtocolVisit;
    yearLength: number;
    possibleVisits?: VisitPossibility[];
};

export default function VisitLine({ visit, yearLength, possibleVisits = [] }: Props) {
    const theme = useTheme();
    const visitColor = darken(theme.palette.primary.light, visit.number / 10);
    return (
        <Stack key={visit.id} direction="row">
            <Typography width={24}>#{visit.number}</Typography>
            <Box
                key={visit.id}
                sx={{
                    position: "relative",
                    height: 24,
                    flex: 1,
                }}
            >
                {possibleVisits.map((possibleVisit, index) => (
                    <PossibleVisitIndicator
                        key={index}
                        color={visitColor}
                        yearLength={yearLength}
                        possibleVisit={possibleVisit}
                    />
                ))}
            </Box>
        </Stack>
    );
}
